import type { I18nLike } from '@bingads-webui/common-types';

import NewCampaign from '../../media/NewCampaign.svg';
import GoogleImport from '../../media/GoogleImport.svg';
import FacebookImport from '../../media/FacebookImport.svg';
import RebrandingNewCampaign from '../../media/RebrandingNewCampaign.svg';
import RebrandingGoogleImport from '../../media/RebrandingGoogleImport.svg';
import RebrandingFacebookImport from '../../media/RebrandingFacebookImport.svg';

export const CampaignCreationMethod = {
  NEW_CAMPAIGN: 'NEW_CAMPAIGN',
  GOOGLE_IMPORT: 'GOOGLE_IMPORT',
  FACEBOOK_IMPORT: 'FACEBOOK_IMPORT',
};

export type CampaignCreationMethodValue = typeof CampaignCreationMethod[keyof typeof CampaignCreationMethod];

export interface CampaignCreationMethodDefinition {
  method: CampaignCreationMethodValue;
  imageSrc: string;
  content: string;
  forceContentInTwoLines: boolean;
  alt: string;
  label: string;
  disabled: boolean;
  disableText?: string;
}

export type I18n = Pick<I18nLike, 'getString'>;

export function getCampaignCreationMethod(
  disableImports: boolean,
  isVertical: boolean,
  isRebranding: boolean,
  isHideImports: boolean
): CampaignCreationMethodDefinition[] {
  if (isHideImports) {
    return [{
      method: CampaignCreationMethod.NEW_CAMPAIGN,
      imageSrc: isRebranding ? RebrandingNewCampaign : NewCampaign,
      content: _TL_('Create account'),
      forceContentInTwoLines: false,
      alt: _TL_('Create account'),
      label: _TL_('Option of create new account'),
      disabled: false,
    }];
  }

  return [{
    method: CampaignCreationMethod.NEW_CAMPAIGN,
    imageSrc: isRebranding ? RebrandingNewCampaign : NewCampaign,
    content: _TL_('Create account'),
    forceContentInTwoLines: false,
    alt: _TL_('Create account'),
    label: _TL_('Option of create new account'),
    disabled: false,
  }, {
    method: CampaignCreationMethod.GOOGLE_IMPORT,
    imageSrc: isRebranding ? RebrandingGoogleImport : GoogleImport,
    content: _TL_('Import from Google Ads'),
    forceContentInTwoLines: !isVertical,
    alt: _TL_('Import from Google Ads'),
    label: _TL_('Option of import from Google Ads'),
    disabled: disableImports,
    disableText: _TL_('This option is only available on desktop'),
  }, {
    method: CampaignCreationMethod.FACEBOOK_IMPORT,
    imageSrc: isRebranding ? RebrandingFacebookImport : FacebookImport,
    content: _TL_('Import from Meta Ads'),
    forceContentInTwoLines: !isVertical,
    alt: _TL_('Import from Meta Ads'),
    label: _TL_('Option of import from Meta Ads'),
    disabled: disableImports,
    disableText: _TL_('This option is only available on desktop'),
  }];
}
